import Animation from "./animation";
export default class FontSheet extends Animation {
    constructor({ asset, sprite, code }) {
        var _a, _b, _c, _d;
        super({ asset, sprite });
        this.type = "fontSheet";
        this.letterWidth = [];
        this.tempCanvas = document.createElement("canvas");
        this.codeToFrame = {};
        this.tempCanvas.width = (_b = (_a = sprite === null || sprite === void 0 ? void 0 : sprite.width) !== null && _a !== void 0 ? _a : asset === null || asset === void 0 ? void 0 : asset.image.naturalWidth) !== null && _b !== void 0 ? _b : 0;
        this.tempCanvas.height = (_d = (_c = sprite === null || sprite === void 0 ? void 0 : sprite.height) !== null && _c !== void 0 ? _c : asset === null || asset === void 0 ? void 0 : asset.image.naturalHeight) !== null && _d !== void 0 ? _d : 0;
        this.tempContext = this.tempCanvas.getContext("2d");
        this.code = code;
        code.split("").forEach((letter, index) => this.codeToFrame[letter] = index);
    }
    getCropForLetter(letter) {
        return this.getCrop(this.codeToFrame[letter]);
    }
    getCrop(frame) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const crop = super.getCrop(frame);
        if (typeof (this.letterWidth[frame]) === 'undefined') {
            this.letterWidth[frame] = crop[2];
            if (this.tempContext && ((_a = this.asset) === null || _a === void 0 ? void 0 : _a.image)) {
                const naturalWidth = (_c = (_b = this.asset) === null || _b === void 0 ? void 0 : _b.image.naturalWidth) !== null && _c !== void 0 ? _c : 0;
                const naturalHeight = (_e = (_d = this.asset) === null || _d === void 0 ? void 0 : _d.image.naturalHeight) !== null && _e !== void 0 ? _e : 0;
                const spriteWidth = (_g = (_f = this.sprite) === null || _f === void 0 ? void 0 : _f.width) !== null && _g !== void 0 ? _g : 0;
                const spriteHeight = (_j = (_h = this.sprite) === null || _h === void 0 ? void 0 : _h.height) !== null && _j !== void 0 ? _j : 0;
                const numCols = spriteWidth ? naturalWidth / spriteWidth : 1;
                const numRows = spriteHeight ? naturalHeight / spriteHeight : 1;
                const totalFrames = this.totalFrames || numCols * numRows;
                const localFrame = Math.min(frame, totalFrames - 1);
                const col = localFrame % numCols;
                const row = Math.floor(localFrame / numCols);
                this.tempContext.clearRect(0, 0, this.tempCanvas.width, this.tempCanvas.height);
                this.tempContext.drawImage((_k = this.asset) === null || _k === void 0 ? void 0 : _k.image, col * spriteWidth, row * spriteHeight, spriteWidth, spriteHeight, 0, 0, spriteWidth, spriteHeight);
                this.letterWidth[frame] = this.findSmallestWidth(this.tempContext);
            }
        }
        crop[2] = this.letterWidth[frame];
        return crop;
    }
    findSmallestWidth(context) {
        const data = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
        for (let w = data.width; w > 0; w--) {
            for (let y = 0; y < data.height; y++) {
                const i = ((w - 1) + y * data.width) * 4;
                if (data.data[i + 3] > 0) {
                    return w; //  found non-blank pixel.
                }
            }
        }
        return 1;
    }
}
